angular
  .module('directives.uiRouterTitle', [])
  .directive('uiRouterTitle', ["$rootScope", "$timeout", function($rootScope, $timeout) {
      return {
        link: function(scope, element) {

          // var listener = function(event, toState) {
          //   if (!toState.title) {
          //     return;
          //   }
          //
          //   $timeout(function() {
          //     element.text(toState.title);
          //   });
          // };
          //
          // $rootScope.$on('$stateChangeSuccess', listener);
        }
      };
  }]);



// WEBPACK FOOTER //
// ./client/src/common/directives/uiRouterTitle.js